import { TextareaHTMLAttributes, forwardRef } from 'react';

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
  helper?: string;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, error, helper, className = '', ...props }, ref) => {
    return (
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-1.5" htmlFor={props.id}>
          {label}
          {props.required && <span className="text-accent-600 ml-1">*</span>}
        </label>
        
        <textarea
          ref={ref}
          className={`w-full px-3 py-2 border ${
            error ? 'border-accent-500' : 'border-gray-300'
          } rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all min-h-[120px] ${className}`}
          {...props}
        />
        
        {error ? (
          <p className="mt-1 text-sm text-accent-600">{error}</p>
        ) : helper ? (
          <p className="mt-1 text-sm text-gray-500">{helper}</p>
        ) : null}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;